import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import GigyaManager from "../business/GigyaManager";
import RestManager from "../business/RestManager";
class HaiVintoCtrl extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.init();
    }
    init() {
        this.loadChildComponents(this);
        let pt = this.getUrlParameter("pt");
        if(pt){
            $('#premio-visual').fadeIn(300);
            let pm = this.getUrlParameter("pm");
            $('#richiedi-premio').attr("href","/promozioni/vinci-il-buongiorno/completa-dati?pt="+pt+"&pm="+pm)
        }else{
            //TODO Gestire errore no parametri
        }

    }

    getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

}

export default HaiVintoCtrl;
